var keyMirror = require('keymirror');

module.exports = keyMirror({
    GET_DOMAIN_DETAILS:null
})